import { Component, Event, EventEmitter, h, Prop, State } from '@stencil/core';
import { DocumentSelectorModal } from 'src/components/concourse-documents/document-selector-modal';

@Component({
  tag: 'concourse-file-uploader',
  styleUrl: 'concourse-file-uploader.css',
})
export class ConcourseFileUploader {
  private browseButton: HTMLInputElement;

  @Prop() projectId: string;
  @Prop() multiple: boolean = true;
  @Prop() accept?: string; // e.g., "image/*", ".pdf,.doc"
  @Prop() disabled?: boolean = false;

  @Event() filesSelected: EventEmitter<File[]>;

  @State() isDragging: boolean = false;

  onUploaded(files: FileList | null) {
    if (!files || files.length === 0) return;
    this.filesSelected.emit(Array.from(files));
  }

  onDragOver(e: DragEvent) {
    e.preventDefault();
    if (!this.disabled) {
      this.isDragging = true;
    }
  }

  onDragOut(e: DragEvent) {
    e.preventDefault();
    this.isDragging = false;
  }

  onDrop(ev: DragEvent) {
    ev.preventDefault();
    this.isDragging = false;

    if (this.disabled) return;

    const files = this.parseDataTransfer(ev.dataTransfer);
    if (files.length > 0) {
      this.filesSelected.emit(files);
    }
  }

  async onDropMouseUp() {
    if (!this.disabled) {
      //this.browseButton.click();
      const files = await DocumentSelectorModal.present(this.projectId, null);
    }
  }

  parseDataTransfer(transfer: DataTransfer): File[] {
    if (transfer.items) {
      return Array.from(transfer.items)
        .map((item: DataTransferItem) => item.getAsFile())
        .filter(file => file !== null);
    }
    return Array.from(transfer.files);
  }

  render() {
    return (
      <div class="concourse-file-uploader">
        <div
          class={this.isDragging ? 'center-content drag-over' : 'center-content drop-zone'}
          style={{ width: '100%', height: '100px', flexDirection: 'column' }}
          onDragOver={e => this.onDragOver(e)}
          onDragLeave={e => this.onDragOut(e)}
          onDrop={e => this.onDrop(e)}
          onMouseUp={() => this.onDropMouseUp()}
        >
          <div>
            <div>
              <span class="ion-hide-md-down">Drag and drop or</span> <span class="browse-files">browse files</span>
            </div>
            <ion-icon name="cloud-upload-outline" size="large"></ion-icon>
          </div>
        </div>
        <input
          id="browse-button"
          type="file"
          ref={el => (this.browseButton = el)}
          onChange={e => this.onUploaded((e.target as HTMLInputElement).files)}
          multiple={this.multiple}
          accept={this.accept}
          disabled={this.disabled}
          hidden
        />
      </div>
    );
  }
}
